import React, { FC } from 'react';
import { ImproveRequiredTabProps } from './ImproveRequiredTabProps';
import useTranslation from '../../hooks/useTranslation';
import ProjectNameInput from '../ProjectTab/ProjectNameInput';
import ProjectDatesFields from '../ProjectTab/ProjectDatesFields';
import SiteInfoSelects from '../SiteTab/SiteInfoFields/SiteInfoSelects';
import LocationInfoCountrySelect from '../SiteTab/LocationInfoCountrySelect';
import ProjectCountryResponsible from '../ProjectCountryResponsible';
import ProjectConfidentialButton from '../ProjectTab/ProjectConfidentialButton';
import Text from '@ingka/text';
import BUInput from '../SiteTab/BUInputs';
import ProjectTabImproveSolutions from '../ProjectTabImproveSolutions';
import { Divider } from '@mui/material';

const ImproveRequiredTab: FC<ImproveRequiredTabProps> = ({
  countries,
  isConfidentialAllowed,
  usersList,
  onCountryChanged,
  onBUChange,
  BUList,
}) => {
  const t = useTranslation();
  return (
    <>
      <Text textStyle="Heading.S" tagName="h4">
        {t('labels.projectInformation')}
      </Text>
      <ProjectNameInput />
      <ProjectDatesFields openingDate />
      <LocationInfoCountrySelect
        countries={countries}
        onCountryChange={onCountryChanged}
      />
      <BUInput BuList={BUList} onBUChange={onBUChange} required />
      <SiteInfoSelects unitType transactionType unitCategoryDisabled />
      <ProjectCountryResponsible usersList={usersList} required={true} />
      <Divider />
      <Text textStyle="Heading.S" tagName="h4">
        Solutions
      </Text>
      <ProjectTabImproveSolutions hideTitle />
      <Divider />
      {isConfidentialAllowed && <ProjectConfidentialButton />}
    </>
  );
};

export default ImproveRequiredTab;
